import { apiClient } from 'pobble-components/dist/api'

export const apiUpdateSlide = (id, data, params) =>
  apiClient.put(`v3/slides/${id}`, data, { params })

export const apiUploadImage = (id, data, params) => {
  const formData = new FormData()
  Object.keys(data).forEach(key => formData.append(key, data[key]))
  return apiClient.post(`/v3/slides/${id}/upload_image`, formData, { params })
}

export const apiRemoveImage = (id, params) =>
  apiClient.delete(`v3/slides/${id}/remove_image`, { params })

export const apiCreateSlide = (presentationId, data, params) =>
  apiClient.post(`/v3/presentations/${presentationId}/slides`, data, { params })

export const apiDeleteSlide = id => apiClient.delete(`/v3/slides/${id}`)

export const apiReorderSlides = (id, data) =>
  apiClient.put(`/v3/presentations/${id}/reorder_slides`, data)

export const apiCrawlLink = (data, params) =>
  apiClient.post('/v3/links', data, { params })

export const apiUnsplashSearch = params =>
  apiClient.get('/v3/unsplash', { params })

export const apiShareBulk = data =>
  apiClient.post('/v3/bulk_presentation_share', data)

export const apiRemoveSharedPresentation = presentationId =>
  apiClient.delete(`/v3/shared_presentations/${presentationId}`)

export const apiGetSharedPresentation = (id, params) =>
  apiClient.get(`/v3/shared_presentations/${id}`, { params })

export const apiGetPresentation = (id, params) =>
  apiClient.get(`/v3/presentations/${id}`, { params })

export const apiMarkAsSeen = id =>
  apiClient.put(`/v3/shared_presentations/${id}/mark_as_seen`)

export const apiMarkAsUnseen = id =>
  apiClient.put(`/v3/shared_presentations/${id}/mark_as_unseen`)

export const apiSetPresentationToPrivate = id =>
  apiClient.put(`/v3/presentations/${id}/set_to_private`)

export const apiSetPresentationToPublic = (id, params) =>
  apiClient.put(`/v3/presentations/${id}/set_to_public`, null, { params })

export const apiDuplicateSlide = (id, params) =>
  apiClient.post(`/v3/slides/${id}/duplicate_slide_in_presentation`, null, {
    params
  })

export const apiUpdatePresentationProperties = (id, data, params) =>
  apiClient.put(`/v3/presentations/${id}/set_presentation_properties`, data, {
    params
  })

export const apiPresentationSearch = params =>
  apiClient.get(`/v3/presentations/search`, { params })

export const apiGetP365Today = params =>
  apiClient.get('/v3/p365/today', { params })

export const apiGetPresentations = params =>
  apiClient.get('/v3/me/presentations', { params })

export const apiCreatePresentation = data =>
  apiClient.post('/v3/presentations', data)

export const apiCopyPresentation = (id, data, params) =>
  apiClient.post(`/v3/presentations/${id}/create_presentation_copy`, data, {
    params
  })

export const apiDeletePresentation = id =>
  apiClient.delete(`v3/presentations/${id}`)

export const apiSuccessCriteriaSearch = params =>
  apiClient.get(`/v3/success_criteria_search`, { params })

export const apiCreateImageAsset = (data, params) =>
  apiClient.post(`v3/presentations/create_image_asset`, data, { params })
